import moment from 'moment';
import isString from 'lodash/isString';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimeField as MuiTimeField} from '@mui/x-date-pickers/TimeField';
import Stack from "@mui/material/Stack";

import CustomInputLabel from './CustomInputLabel';

const TimeField = props => {
  const startOfDay = moment().startOf('day').hour(9);
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack paddingTop={0.1}>
        {props?.label && <CustomInputLabel required={props.required || false}>
          {props.label}
        </CustomInputLabel>}
        <MuiTimeField
          color={props?.color || 'primary'}
          label={null}
          placeholder='09:00 AM'
          sx={{
            maxWidth: '100%',
            'input': { padding: '11px 14px' }
          }}
          defaultValue={
            isString(props.defaultValue)
            ? moment(props.defaultValue, 'hh:mm a')
            : null
          }
          onChange={momentObj => props.onChange({
            target: {value: momentObj.format('hh:mm a')},
          }, momentObj.format('hh:mm a'))}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default TimeField;